import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { authRoutesNames } from 'src/core/routes/auth/auth.routes.names';
import { coreRoutesNames } from 'src/core/routes/core.routes.names';
import { AuthStore } from 'src/core/stores';
import { CoreTenantsService } from 'src/generated/api/nestjs-backend';

@Component({
  selector: 'core-redirect',
  templateUrl: 'redirect.component.html',
  standalone: true,
})
export class RedirectComponent implements OnInit {
  private router = inject(Router);
  private authStore = inject(AuthStore);
  private coreTenantsService = inject(CoreTenantsService);

  ngOnInit(): void {
    this.getDefaultLandingPage().subscribe((landingPage) => {
      this.router.navigateByUrl(landingPage);
    });
  }

  private getDefaultLandingPage(): Observable<string> {
    if (!this.authStore.isAuthenticated()) {
      return of(coreRoutesNames.AUTH + '/' + authRoutesNames.LOGIN);
    }
    return this.coreTenantsService
      .getTenant({ tenantSlug: this.authStore.tenantSlug() })
      .pipe(
        map(
          (tenantDto) =>
            tenantDto.configurations?.['defaultLandingPage'] ??
            coreRoutesNames.DASHBOARD,
        ),
        catchError(() => of(coreRoutesNames.DASHBOARD)),
      );
  }
}
